const de = {
  common: {
    home: 'Startseite',
    email: 'Mailadresse',
    first_name: 'Vorname',
    last_name: 'Nachname',
    password: 'Passwort',
    repeat_password: 'Passwort wiederholen',
    forgot_password: 'Passwort vergessen?',
    new_password: 'Neues Passwort',
    old_password: 'Altes Passwort',
    change_password: 'Passwort ändern',
    cancel: 'Abbrechen',
    continue: 'Weiter',
    success: 'Erfolg!',
    error: 'Fehler',
    or: 'oder',
    back: 'Zurück',
    signoff: 'Abmelden',
    edit: 'Bearbeiten',
    actions: 'Aktionen',
    save: 'Speichern',
    delete_device: 'Gerät löschen',
    delete_device_named: 'Gerät löschen #{name}',
    open_device: 'Gerät öffnen',
    view_device: 'Gerät ansehen',
    page: 'Seite',
    close: 'Schließen',
    not_authorized: 'Nicht autorisiert',
    access_denied: 'Du hast keine Berechtigung, auf diese Seite zuzugreifen.',
    oops: 'Ups!',
    no_access_message: 'Anscheinend bist du nicht berechtigt, diese Ressource anzuzeigen. Bitte wende dich an den Support, wenn du glaubst, dass dies ein Fehler ist.',
    return_home: 'Zurück zur Startseite',
    next: 'Nächste',
    previous: 'Zurück',
    confirm_delete: 'Bist du dir sicher?',
    confirm_delete_message: 'Möchtest du dieses Gerät wirklich trennen?',
    delete: 'Löschen',
    remove: 'Entfernen',
    loading: 'Wird geladen…',
    select_all: 'Alle auswählen',
    search: 'Suche nach Name oder Typ…',
    search_user: 'Suche nach Benutzer oder Gerät',
    elements_per_page: 'Elemente pro Seite',
    copied: 'Kopiert',
    copy_key: 'Verifizierungsschlüssel kopieren',
    reload: 'Neu laden',
    support: 'Support',
    successfully_saved: 'Änderungen erfolgreich gespeichert!',
    password_requirements: 'Dein Passwort muss die folgenden Anforderungen erfüllen:',
    enter_password: 'Gib dein Passwort ein',
    password_invalid: 'Das eingegebene Passwort ist ungültig.',
    password_weak:'Schwaches Passwort',
    password_medium:'Mittleres Passwort',
    password_strong:'Starkes Passwort',
    no_results: 'Keine Ergebnisse gefunden.',
    no_data: 'Keine Daten verfügbar.',
    open: 'Öffnen',
    apps_services: 'Apps & Dienste',
    trigger_notification: 'Benachrichtigung auslösen',
    open_externally: 'Extern öffnen',
    yes: 'Ja',
    no: 'Nein',
    columns: 'Spalten',
  },
  errors: {

    global: 'Es ist ein Fehler aufgetreten.',
    unknown: 'Es ist ein unbekannter Fehler aufgetreten.',
    too_many_attempts: 'Zu viele Anmeldeversuche. Bitte versuche es in {seconds} Sekunden erneut.',
    could_not_authenticate: 'Benutzer konnte nicht authentifiziert werden.',
    invalid_email: 'Ungültige Mailadresse',
    no_setup_key: 'In der Antwort wurden keine Verbindungsschlüssel gefunden.',
    endpoint_not_created_yet: 'Endpunkt wurde noch nicht erstellt.',

    accountAwaitsTenantOwnership: "Dieses Konto ist zur Eigentümerschaft eines Mandanten eingeladen. Es wird erst mit dem Löschen dieses Mandanten entfernt.",
    accountBehindOpenInvitation: "Dieses Konto gehört zu einer offenen Einladung. Es wird entfernt, indem die Einladung zurückgezogen wird.",
    accountDeactivated: "Das Konto zu dieser Adresse ist deaktiviert.",
    accountDeletionPending: "Das Konto zu dieser Adresse wird gerade gelöscht. Die Adresse ist erst danach wieder verwendbar.",
    adminCannotDeleteOwnAccount: "Sie können Ihr eigenes Konto nicht löschen.",
    alreadyViewer: "Dieser Benutzer hat bereits Zugriff auf das Gerät.",
    accountOwnsDevices: "Das Konto zu dieser Adresse besitzt Geräte. Ein Konto mit eigenen Geräten kann nicht Mitglied eines Mandanten werden.",
    cannotRemoveTenantOwner: "Der Mandanteninhaber kann nicht aus dem Mandanten entfernt werden. Nur eine Übertragung der Eigentümerschaft wechselt den Inhaber.",
    cannotDeleteTenantOwner: "Das Konto eines Mandanteninhabers kann nicht gelöscht werden. Zuerst muss die Eigentümerschaft übertragen werden.",
    memberNotFound: "Diese Person ist nicht mehr Mitglied des Mandanten.",
    inviteeIsTenantMember: "Diese Adresse gehört einem Mitglied eines Mandanten. Geräte gehen nur an Endkunden.",
    deviceNotInTenant: "Das Gerät gehört nicht mehr zu diesem Mandanten.",

    authenticationCookieRequired: "Authentifizierungs-Cookie ist erforderlich.",
    authenticationRequired: "Authentifizierung ist erforderlich.",
    authenticationRequiredForTopics: "Authentifizierung ist für diese Themen erforderlich.",

    deviceAccessDenied: "Sie haben keinen Zugriff auf dieses Gerät.",
    deviceIdRequired: "Geräte-ID ist erforderlich.",
    deviceIdRequiredInUri: "Geräte-ID ist in der URL erforderlich.",
    deviceInvalidIpAddress: "Die IP-Adresse des Geräts ist ungültig.",
    deviceIpNotInAllowedRange: "Die IP-Adresse des Geräts liegt nicht im erlaubten Bereich.",
    deviceNotFound: "Gerät nicht gefunden.",
    deviceNoIpAddress: "Dem Gerät ist keine IP-Adresse zugewiesen.",
    deviceUnavailable: "Das Gerät ist derzeit nicht verfügbar.",
    deviceUnreachable: "Das Gerät ist nicht erreichbar.",

    emailNotVerified: "Ihre E-Mail-Adresse ist nicht verifiziert.",
    email_not_verified: 'Deine E-Mail-Adresse ist nicht verifiziert.',
    emailAlreadyExists : "Ein Konto mit dieser E-Mail-Adresse existiert bereits.",

    fbSignedRequestEmpty: "Facebook Signed Request ist leer.",
    fbSignedRequestInvalidBase64: "Facebook Signed Request enthält ungültige Base64-Daten.",
    fbSignedRequestInvalidPayload: "Facebook Signed Request Payload ist ungültig.",
    fbSignedRequestMalformed: "Facebook Signed Request ist fehlerhaft.",
    fbSignedRequestSignatureMismatch: "Facebook Signed Request Signatur stimmt nicht überein.",

    fcmAccessTokenMissing: "FCM-Zugriffstoken fehlt.",
    fcmAuthFailed: "Authentifizierung mit Firebase Cloud Messaging fehlgeschlagen.",
    fcmInvalidPrivateKey: "Ungültiger Firebase Private Key.",
    fcmJwtSigningFailed: "Firebase JWT-Signierung fehlgeschlagen.",

    handledStampNotFound: "Verarbeiteter Zeitstempel nicht gefunden.",

    headerInvalidType: "Ungültiger Header-Typ.",
    headerNotAllowed: "Dieser Header ist nicht erlaubt.",
    headerValueTooLong: "Header-Wert ist zu lang.",

    httpMethodNotAllowed: "HTTP-Methode nicht erlaubt.",

    idpUnexpectedError: "Unerwarteter Fehler beim Identity Provider.",
    internalError: "Interner Serverfehler.",

    invalidCredentials: "Ungültige Zugangsdaten.",
    invalidLogLevel: "Ungültiges Log-Level.",
    invalidUserClass: "Ungültige Benutzerklasse.",
    invitationConflict: "Für diese Adresse gibt es eine offene Einladung, die sich damit nicht verträgt. Sie muss zuerst zurückgezogen werden.",

    messageHandlerNoResult: "Message-Handler hat kein Ergebnis zurückgegeben.",

    netbirdApiError: "NetBird API-Fehler.",
    netbirdClientRequestFailed: "NetBird Client-Anfrage fehlgeschlagen.",
    netbirdEmbeddedGroupNotFound: "Eingebettete NetBird-Gruppe nicht gefunden.",
    netbirdRequestFailed: "NetBird-Anfrage fehlgeschlagen.",

    oidcUserCreationFailed: "Benutzererstellung über OpenID Connect fehlgeschlagen.",

    pathEmpty: "Pfad darf nicht leer sein.",
    pathInvalidStart: "Pfand hat einen ungültigen Anfang.",
    pathTooLong: "Pfad ist zu lang.",
    pathTraversalNotAllowed: "Pfad-Traversierung ist nicht erlaubt.",

    payloadTooLarge: "Payload ist zu groß.",
    rateLimitExceeded: "Zu viele Anfragen. Bitte versuchen Sie es später erneut.",

    requestNotFoundInContext: "Anfrage im Kontext nicht gefunden.",
    requestRequired: "Anfrage ist erforderlich.",

    sessionNotFound: "Sitzung nicht gefunden.",
    sharedDeviceRemoveTenantAccessInstead: "Ein geteiltes Gerät kann nicht entfernt werden. Entfernen Sie stattdessen den Mandantenzugriff.",

    ssoEmailExists: "Ein Konto mit dieser E-Mail-Adresse existiert bereits.",
    ssoMissingIdOrToken: "SSO-ID oder Token fehlt.",
    ssoMultipleUsersFound: "Mehrere Benutzer für dieses SSO-Konto gefunden.",
    ssoUserIdNotFound: "SSO-Benutzer-ID nicht gefunden.",

    storageEncodingFailed: "Speicher-Kodierung fehlgeschlagen.",
    storageRecordCorrupted: "Gespeicherter Datensatz ist beschädigt.",

    technicianNameRequiresTenantMembership: "Ein interner Name kann nur für Geräte festgelegt werden, die einem Mandanten zugeordnet sind.",
    tenantDeviceAccessNotRemovable: "Bei einem Mandantengerät kann der Mandantenzugriff nicht entfernt werden.",
    tenantNameAlreadyTaken: "Dieser Mandantenname ist bereits vergeben.",
    tenantNameRequired: "Bitte geben Sie einen Mandantennamen ein.",
    tenantNameTooLong: "Der Mandantenname darf höchstens 100 Zeichen lang sein.",
    tenantAwaitingOwner: "Der Mandant wartet noch auf seinen Inhaber. Das ist erst möglich, wenn dieser die Einladung angenommen hat.",
    futureTenantOwnerIsOrgAdmin: "Ein Organisationsadministrator kann nicht Inhaber eines Mandanten werden.",
    futureTenantOwnerIsOnlyInvited: "Das Konto zu dieser Adresse wurde noch nicht eingerichtet. Es kann erst Inhaber werden, wenn die Einrichtung abgeschlossen ist.",

    unauthorized: "Sie sind nicht berechtigt, diese Aktion auszuführen.",
    unauthorizedRoleAssignment: "Sie dürfen diese Rolle nicht zuweisen.",
    insufficientRole: "Sie haben nicht die erforderlichen Berechtigungen für diese Aktion.",

    userDeleteForbidden: "Sie dürfen diesen Benutzer nicht löschen.",
    userAlreadyBelongsToTenant: "Dieser Benutzer gehört bereits zu einem Mandanten.",
    userIdParameterRequired: "Benutzer-ID-Parameter ist erforderlich.",
    userIdRequired: "Benutzer-ID ist erforderlich.",
    userInactive: "Dieser Benutzer ist inaktiv.",
    userNotFound: "Benutzer nicht gefunden.",

    zitadelClientRequestFailed: "Zitadel Client-Anfrage fehlgeschlagen.",
    zitadelRequestFailed: "Zitadel-Anfrage fehlgeschlagen.",
    zitadelUserNotActive: "Ihr Konto ist nicht aktiv. Bitte wenden Sie sich an Ihren Administrator.",

    invalid_password: 'Das eingegebene Passwort ist ungültig.',
  },

  verification: {
    invalid_verification_link: 'Ungültiger Bestätigungslink',
    success: 'Ihre Mailadresse wurde erfolgreich bestätigt.',
    fehlgeschlagen: 'Konnte nicht verifiziert werden {error}',
    invalid_link: 'Ungültiger Link',
    verifying_account: 'Ihr Konto wird verifiziert...',
    email_not_received: 'E-Mail nicht erhalten?',
    resend_email: 'E-Mail erneut senden',
    sending: 'E-Mail wird gesendet',
    resend_email_failed: 'Bestätigungs-E-Mail konnte nicht erneut gesendet werden.',
    resend_email_email_success: 'Bestätigungs-E-Mail erfolgreich gesendet!',
    email_not_found: 'E-Mail nicht gefunden',
    error_resending_email: 'Fehler beim erneuten Senden der E-Mail',
    email_resent: 'Die Verifizierungsmail wurde erneut gesendet. Falls du keine Mail von uns erhalten hast, bitte wende dich an den {support}.'

  },

  registration: {
    register: 'Registrieren',
    register_now: 'Jetzt registrieren',
    name: 'Name',
    repeat_password: 'Passwort wiederholen',
    already_signed_up: 'Bereits registriert?',
    sign_up: 'Registrieren',
    sign_up_subtitle: 'Erstelle ein Konto, um deine Geräte zu verwalten.',
    sign_up_here: 'Hier registrieren',
    get_started: 'Loslegen',
    no_account_yet: 'Noch kein Konto?',
    log_in_here: 'Hier einloggen',
    check_email: 'Bitte überprüfe deinen Posteingang und bestätige deine E-Mail-Adresse.',
    password_changed: 'Passwort erfolgreich geändert.',
    password_updated: 'Ihr Passwort wurde aktualisiert.',
    recheck_email: 'Du hast deine E-Mail-Adresse noch nicht verifiziert. Bitte verifiziere diese, um die App zu nutzen.',
    confirm_email: 'Bitte bestätige deine E-Mail-Adresse.',
    didnt_receive_email: 'Hast du keine E-Mail erhalten?',
    user_already_exists: 'Benutzer existiert bereits.',
    sign_up_error: 'Bei der Anmeldung ist ein Fehler aufgetreten.',
    check_credentials: 'Bitte überprüfe deine Anmeldeinformationen.',
    terms_and_conditions: 'Ich habe die {terms} und die {privacy} gelesen und stimme diesen zu.',
    terms: 'AGB',
    privacy: 'Datenschutzerklärung',


  },

  login: {
    login: 'Anmelden',
    auth: 'Authentifizierung',
    login_or_register: 'Anmelden oder Registrieren',
    sign_in: 'Einloggen',
    sign_in_subtitle: 'Melde dich an, um deine Geräte zu verwalten.',
    reset_target_override: 'Auf Standardserver zurücksetzen',
    continue_with_email: 'Mit Mailadresse fortfahren',
    tell_us_email: 'Teile uns die E-Mail-Adresse deines Kontos mit.',
    login_google: 'Mit Google anmelden',
    login_facebook: 'Mit Facebook anmelden',
    login_apple: 'Mit Apple anmelden',
    enter_the_code: 'Gib hier den Code ein, den wir Dir gesendet haben.',
    choose_new_password: 'Wähle ein neues Passwort und fahre fort.',
    wrong_username_password: 'Du hast einen ungültigen Benutzernamen oder ein ungültiges Passwort eingegeben.',
    passwords_does_not_match: 'Die Passwörter stimmen nicht überein.',
    login_instructions: 'Wir haben Dir eine E-Mail mit Anweisungen zum Zurücksetzen Deines Passworts gesendet. Bitte überprüfe Deinen Posteingang.',
    sign_up: 'Registrieren',
    sign_in_with_email: 'Mit E-Mail anmelden',
  },

  terms: {
    terms_of_Service: 'AGB',
    privacy_policy: 'Datenschutzhinweise',
    imprint: 'Impressum',
    text: 'Indem du fortfährst, stimmst du dem folgenden zu:',
    support: 'Support',
  },

  start: {
    welcome: 'Willkommen!',
    welcome_msg: 'Verwalte deine energielenker-Geräte schnell und einfach. Behalte jederzeit und überall die Kontrolle.',
    lets_start: 'Lass uns anfangen',
  },

  menu: {
    settings: 'Einstellungen',
    plans: 'Pläne',
    home: 'Startseite',
    admin: 'Verwaltung',
  },

  home: {
    title: 'Deine Geräte',
    subtitle: 'Geräte verwalten',
    add_device: 'Gerät verbinden',
    no_devices: 'Du hast noch keine Geräte mit deinem Konto verknüpft.',
    edit_device: 'Gerät bearbeiten',
    device_name: 'Gerätename',
    device_created: 'Enbas erfolgreich erstellt!',
    copy_key: 'Hinterlege den Schlüssel in deinen Geräteeinstellungen.',
    add_another_device: 'Füge weitere Geräte hinzu',
    apps_title: 'Deine Apps',
    apps_subtitle: 'Verwalte deine Geräte und greife von überall darauf zu.',
    services_title: 'Deine Services',
    services_subtitle: 'Wähle einen Service – Schritt für Schritt zur richtigen Lösung mit automatischer Preisberechnung.',
    open_solution_builder: 'Solution Builder öffnen',
    services_choose: 'Service wählen',
    cems_subtitle: 'Kaufmännisches Energiemanagement',
    cems_title: 'Solution Builder',
    cems_title_full: 'CEMS Solution Builder',
    cems_description: 'Tool zur Konfiguration cloudbasierter Commercial Energy Management Lösungen.',
    cems_tags: 'CEMS|Monitoring & Analyse|Energiefahrplan|Lastmanagement',
    eza_subtitle: 'EZA-Regler & Parksteuerungen',
    eza_title: 'Solution Builder',
    eza_title_full: 'EZA Solution Builder',
    eza_description: 'Konfiguration zertifizierter EZA-Regler gemäß VDE-AR-N 4105/4110/4120 inkl. Lizenzen, Erzeugungsanlagen, Inbetriebnahme und Hardware-Optionen.',
    eza_tags: 'VDE-AR-N 4105|VDE-AR-N 4110/4120|Redispatch|Parksteuerung',
    org_admin_hint: 'Als Organisations-Admin findest du alle Geräte in der Geräteverwaltung.',
    org_admin_link: 'Zur Geräteverwaltung',
    no_end_customer: 'Noch kein Endkunde',
    end_customer: 'Endkunde: {name} ({email})',
    open_handover: 'Übergabe an {email} offen',
  },

  admin: {
    title: 'Verwaltung',
    subtitle: 'Alle Benutzer und ihre Geräte anzeigen',
    manage_org: 'Organisation verwalten',
    device: 'Gerät',
    devices: 'Geräte',
    tenants: 'Mandanten',
    users: 'Benutzer',
    name: 'Name',
    id: 'ID',
    add_tenant: 'Mandant erstellen',
    create_tenant: 'Mandant erstellen',
    tenant_search_placeholder: 'Mandanten suchen',
    user_search_placeholder: 'Benutzer suchen',
    user_table: {
      name: 'Name',
      role: 'Rolle',
      tenant: 'Mandant',
      status: 'Status',
      devices: 'Geräte',
      devices_breakdown: '{enbas} Enbas / {lobas} Lobas',
    },
    user_overview: {
      title: 'Benutzerübersicht',
      general_info: 'Allgemeine Informationen',
      name: 'Name',
      email: 'E-Mail',
      status: 'Status',
      roles_and_tenants: 'Rollen und Mandanten',
      devices_title: 'Geräte',
      devices_subtitle: 'Der Benutzer ist Eigentümer der folgenden Geräte.',
      activate: 'Aktivieren',
      deactivate: 'Deaktivieren',
      cannot_deactivate_self: 'Sie können Ihr eigenes Konto nicht deaktivieren.',
      edit_user: 'Benutzer bearbeiten',
      delete_user: 'Konto löschen',      edit_role: 'Rolle bearbeiten',      add_tenant_rights: 'Mandantenrechte Hinzufügen',
      toasts: {
        activated: 'Benutzer aktiviert.',
        deactivated: 'Benutzer deaktiviert.',
        user_updated: 'Benutzer aktualisiert.',
        tenant_rights_added: 'Mandantenrechte hinzugefügt.',
      },
      device_table: {
        device: 'Gerät',
        type: 'Typ',
        status: 'Status',
        owner: 'Inhaber',
        authorized: 'Autorisiert',
        users: 'Anzahl Benutzer',
      },
    },
    users_dialogs: {
      invite_user: 'Benutzer einladen',
      invite_header: 'Neuen Benutzer einladen',
      edit_user_header: 'Benutzer bearbeiten',
      fallback_user: 'Benutzer',
      delete_account: {
        header: 'Konto von {name} löschen?',
        own_header: 'Dein Konto löschen?',
        permanent: 'Das Konto wird endgültig gelöscht. Das lässt sich nicht rückgängig machen.',
        devices_title: 'Diese Geräte werden entfernt',
        no_devices: 'Es werden keine Geräte entfernt.',
        unnamed_device: 'Unbenanntes Gerät',
        tenants_title: 'Diese Mandanten verlieren den Zugriff auf Geräte',
        no_tenants: 'Kein Mandant verliert den Zugriff.',
        confirm: 'Konto löschen',
      },
      user_deleted: 'Benutzer gelöscht.',
      choose_tenant: 'Mandant auswählen',
      choose_tenant_helper:
        'Wenn du einen Techniker einlädst, musst du den Benutzer einem Mandanten zuweisen.',
      roles: {
        user: 'Benutzer',
        user_description:
          'Techniker können Mandantengeräte verwalten, haben aber keine Administratorrechte.',
      },
    },
    table: {
      device: 'Gerät',
      type: 'Typ',
      status: 'Status',
      owner: 'Inhaber',
      tenant: 'Mandant',
      access: 'Zugriff',
      access_users: '{count} Benutzer',
      name: 'Name',
      label: 'Bezeichnung',
      internal_name: 'Interner Name',
      system_account: 'Systemkonto',
      kinds: {
        private: 'Gerät eines Endkunden',
        tenant: 'Mandantengerät',
        shared: 'Geteiltes Gerät',
        system_account: 'Gerät des Systemkontos',
      },
      load_failed: 'Die Geräte konnten nicht geladen werden.',
    },
    tenant_form: {
      header: 'Mandant erstellen',
      edit_header: 'Mandant bearbeiten',
      name_label: 'Mandantenname',
      name_placeholder: 'New tenant GmbH',
      name_helper: 'Erklärender Hinweis',
      owner_title: 'Mandanteninhaber',
      owner_description: 'Verwende die E-Mail-Adresse des Mandanteninhabers. Falls dieser noch kein Konto hat, erhält er eine Einladung.',
      owner_first_name_placeholder: 'Karl',
      owner_last_name_placeholder: 'Heinz',
      owner_label_helper: 'Erklärender Hinweis',
      save_changes: 'Änderungen speichern',
      email_label: 'E-Mail-Adresse',
      accounts_notice: 'Geräte von Kunden und des Betriebs gehören in ein geschäftliches Konto. Eigene Geräte des künftigen Inhabers gehören in ein separates privates Konto. Connect trennt beides innerhalb eines Kontos nicht. Gib deshalb die geschäftliche Adresse an.',
      takeover_notice: 'Gehört die Adresse zu einem bestehenden Konto, werden alle Geräte dieses Kontos zu Mandantengeräten. Andere Mandanten verlieren den Zugriff darauf.',
      created_with_owner: 'Der Mandant {name} wurde erstellt. {email} ist sein Inhaber.',
      created_invited: 'Der Mandant {name} wurde erstellt. An {email} wurde eine Einladung gesendet; der Mandant wartet auf seinen Inhaber.',
      edit_owner_hint: 'Den Inhaber änderst du über „Eigentümerschaft übertragen“ in der Mitgliederliste.',
    },
    tenant_overview: {
      title: 'Mandantenübersicht',
      general_info: 'Allgemeine Informationen',
      name: 'Name',
      enbas_device: 'Enbas-Gerät',
      tenant_owner: 'Mandanteninhaber',
      tenant_email: 'Inhaber',
      awaiting_owner: 'Wartet auf Inhaber',
      awaiting_owner_invited: 'Eingeladen: {email}',
      awaiting_owner_hint: 'Die Einladung kannst du unter „Einladungen“ erneut senden. Zurückziehen lässt sie sich nicht; sie endet nur, wenn der Mandant gelöscht wird.',
      edit_tenant: 'Mandant bearbeiten',
      delete_tenant: 'Mandant löschen',
      tabs: {
        members: 'Mandantenmitglied',
        devices: 'Geräte',
      },
      member_table: {
        name: 'Name',
        role: 'Rolle',
        status: 'Status',
      },
      member_status: {
        active: 'Aktiv',
        inactive: 'Inaktiv',
        pending: 'Ausstehend',
      },
      device_table: {
        device: 'Gerät',
        type: 'Typ',
        status: 'Status',
        owner: 'Inhaber',
        users: 'Anzahl Benutzer',
      },
      member_actions: {
        edit_member: 'Mitglied bearbeiten',
        change_role: 'Rolle ändern',
        transfer_ownership: 'Eigentümerschaft übertragen',
        remove_member: 'Aus Mandant entfernen',
        resend_invitation: 'Einladung erneut senden',
        owner_notice: 'Der Mandanteninhaber kann nicht entfernt und seine Rolle nicht geändert werden. Nur eine Übertragung der Eigentümerschaft wechselt den Inhaber.',
        owner_transfer_hint: 'Dazu beim künftigen Inhaber „Eigentümerschaft übertragen“ wählen.',
      },
      roles: {
        technician: 'Techniker',
        admin: 'Admin',
        tenant_admin: 'Mandanten-Admin',
        tenant_owner: 'Mandanteninhaber',
        org_admin: 'Org-Admin',
        user: 'Benutzer',
      },
      change_role: {
        header: 'Rolle ändern',
        subtitle: 'Rolle für {name} ändern.',
        new_role: 'Neue Rolle',
      },
      remove_member: {
        header: 'Aus Mandant entfernen',
        message: '{name} aus dem Mandanten {tenant} entfernen? Das Konto bleibt bestehen. {name} verliert den Zugriff auf die Geräte von {tenant} und kann später erneut eingeladen werden.',
        confirm: 'Aus Mandant entfernen',
      },
      deactivate_confirm: {
        header: '{name} deaktivieren?',
        message: '{name} kann sich nicht mehr anmelden. Mitgliedschaft, Rolle und Geräte bleiben erhalten. Du kannst das Konto jederzeit wieder aktivieren.',
        confirm: 'Deaktivieren',
      },
      toasts: {
        invite_sent: 'Einladung an {email} gesendet. Die Mitgliedschaft wird wirksam, sobald die Einladung angenommen ist.',
        member_added: '{email} ist jetzt Mitglied des Mandanten.',
        invitation_extended: 'Die Mitgliedschaft wurde der offenen Einladung an {email} hinzugefügt. Die Einladungs-E-Mail wurde erneut gesendet.',
        role_updated: 'Rolle für {name} aktualisiert.',
        ownership_transferred: 'Eigentümerschaft an {name} übertragen.',
        member_removed: '{name} wurde aus dem Mandanten entfernt.',
        invitation_resent: 'Einladung erneut an {name} gesendet.',
        tenant_updated: 'Mandant erfolgreich aktualisiert.',
        tenant_deleted: 'Mandant gelöscht.',
        tenant_deleted_accounts_pending:
          'Mandant gelöscht. Die Löschung von {count} Konto beim Identitätsanbieter steht noch aus; sie wird wiederholt, bis sie gelingt. Du findest sie unter „Ausstehende Kontolöschungen“ in der Mandantenliste. | Mandant gelöscht. Die Löschung von {count} Konten beim Identitätsanbieter steht noch aus; sie wird wiederholt, bis sie gelingt. Du findest sie unter „Ausstehende Kontolöschungen“ in der Mandantenliste.',
      },
      invite_member: {
        header: 'Mitglied nicht gefunden',
        message: 'Möchtest du die {email} einladen?',
        invite: 'Einladen',
      },
      edit_member: {
        header: 'Mitglied bearbeiten',
        first_name_label: 'Vorname',
        last_name_label: 'Nachname',
        email_label: 'E-Mail-Adresse',
        status_label: 'Status',
        role_label: 'Rolle',
        devices_title: 'Geräte',
        devices_description: 'Geräte des Benutzers verwalten',
        manage_devices: 'Geräte verwalten',
        services_title: 'Dienste',
        services_description: 'Dienste verwalten',
        manage_services: 'Dienste verwalten',
      },
      add_member: {
        button: 'Mitglied hinzufügen',
        header: 'Mitglied hinzufügen',
        user_label: 'Benutzer oder E-Mail-Adresse eingeben',
        user_helper: 'Gib die E-Mail-Adresse des einzuladenden Benutzers ein.',
        joins_as_technician: 'Neue Mitglieder kommen als Techniker hinzu. Die Rolle kannst du danach ändern.',
        choose_role: 'Rolle auswählen',
        roles: {
          technician: 'Techniker',
          technician_description:
            'Techniker können Mandantengeräte verwalten, haben aber keine Administratorrechte.',
          admin: 'Admin',
          admin_description:
            'Ein Mandanten-Admin kann Mitglieder und Geräte verwalten und hat vollen Zugriff auf die Mandantenverwaltung.',
        },
      },
      showing_entries: '{shown} von {total} Einträgen',
    },
    device_overview: {
      title: 'Geräteübersicht',
      general_info: 'Allgemeine Informationen',
      name: 'Gerätename',
      type: 'Gerätetyp',
      serial_number: 'Seriennummer des Geräts',
      copy_serial_number: 'Seriennummer kopieren',
      owner: 'Geräteinhaber',
      authorized_tenant: 'Autorisierter Mandant',
      internal_name: 'Interner Name',
      status: 'Gerätestatus',
      device_key: 'Geräteschlüssel',
      edit_device: 'Gerät bearbeiten',
      remove_device: 'Gerät entfernen',
      users_title: 'Benutzer',
      add_user: 'Benutzer hinzufügen',
      search_placeholder: 'Benutzer suchen',
      user_table: {
        user: 'Benutzer',
        access_level: 'Zugriffsebene',
      },
      access_levels: {
        owner: 'Inhaber',
        manage: 'Verwalten',
        manage_description: 'Kann das Gerät einsehen und steuern.',
        view: 'Nur ansehen',
        view_description: 'Kann nur den Gerätestatus einsehen.',
      },
      actions: {
        edit_user: 'Benutzer bearbeiten',
        remove_access: 'Zugriff entfernen',
      },
      edit_device_dialog: {
        header: 'Gerät bearbeiten',
        name_label: 'Gerätename',
      },
      add_user_dialog: {
        header: 'Benutzer hinzufügen',
        user_label: 'Benutzer oder E-Mail-Adresse eingeben',
        user_helper: 'Gib die E-Mail-Adresse des Benutzers ein, dem Zugriff gewährt werden soll.',
        choose_access_level: 'Zugriffsebene auswählen',
      },
      edit_user_dialog: {
        header: 'Benutzer bearbeiten',
      },
      remove_access_dialog: {
        header: 'Zugriff entfernen',
        message: 'Möchtest du den Zugriff für {name} wirklich entfernen? Diese Aktion kann nicht rückgängig gemacht werden.',
      },
      toasts: {
        device_updated: 'Gerät erfolgreich aktualisiert.',
        device_removed: 'Gerät erfolgreich entfernt.',
        user_added: 'Benutzer erfolgreich hinzugefügt.',
        user_updated: 'Benutzer erfolgreich aktualisiert.',
        access_removed: 'Zugriff für {name} entfernt.',
      },
      showing_entries: '{shown} von {total} Einträgen',
    },
    pending_account_deletions: {
      heading: 'Ausstehende Kontolöschungen ({count})',
      description:
        'Diese Konten sind in Connect gelöscht, beim Identitätsanbieter aber noch nicht. Die Löschung wird wiederholt, bis sie gelingt; bis dahin ist die Adresse gesperrt.',
      columns: {
        account: 'Konto',
        tenant: 'Mandant',
        attempts: 'Fehlversuche',
        last_failure: 'Letzter Fehler',
      },
      no_failure: '–',
      unknown_tenant: 'unbekannt',
      load_failed: 'Die ausstehenden Kontolöschungen konnten nicht geladen werden.',
    },
    tenant_deletion: {
      header: 'Mandant {name} löschen',
      consequences: {
        immediate: 'Die Löschung wirkt sofort.',
        irrevocable: 'Sie lässt sich weder zurückziehen noch rückgängig machen.',
      },
      state_changed:
        'Seit der Dialog geöffnet wurde, hat sich geändert, was die Löschung betrifft. Prüfe die aktuellen Listen und gib den Namen erneut ein.',
      lists: {
        tenant_devices: {
          heading: 'Geräte, die an das Systemkonto übergehen ({count})',
          empty: 'Keine Geräte gehen an das Systemkonto über.',
        },
        shared_devices: {
          heading: 'Geteilte Geräte, deren Zugriff endet ({count})',
          empty: 'Keine geteilten Geräte sind betroffen.',
          item: '{device} – gehört {owner}',
        },
        deleted_accounts: {
          heading: 'Konten, die gelöscht werden ({count})',
          empty: 'Kein Konto wird gelöscht.',
        },
        kept_accounts: {
          heading: 'Konten, die nur ihre Mitgliedschaft verlieren ({count})',
          empty: 'Kein Konto verliert nur seine Mitgliedschaft.',
        },
        withdrawn_actions: {
          heading: 'Aktionen offener Einladungen, die zurückgezogen werden ({count})',
          empty: 'Keine Aktion wird zurückgezogen.',
          kinds: {
            membership: 'Mitgliedschaft für {email}',
            device_handover: 'Übergabe von {device} an {email}',
            tenant_ownership: 'Mandanteninhaberschaft für {email}',
          },
        },
      },
      name_label: 'Gib zur Bestätigung den Namen des Mandanten ein: {name}',
      confirm: 'Endgültig löschen',
      nothing_changed: 'Es wurde nichts geändert.',
      rejections: {
        name_mismatch: 'Der eingegebene Name stimmt nicht mit dem Namen des Mandanten überein.',
        tenant_not_found: 'Der Mandant wurde nicht gefunden.',
        not_allowed: 'Du darfst diesen Mandanten nicht löschen.',
        failed: 'Die Löschung ist fehlgeschlagen. Versuche es später erneut.',
        outcome_unknown:
          'Ob der Mandant gelöscht wurde, ließ sich nicht feststellen. Lade die Übersicht neu, bevor du es erneut versuchst.',
      },
    },
    tenant_owner_transfer: {
      header: 'Mandanteninhaber wechseln',
      tenant: 'Mandant',
      new_owner: 'Neuer Mandanteninhaber',
      previous_owner: 'Bisheriger Mandanteninhaber',
      previous_owner_you: 'Du',
      devices: 'Geräte, die an den neuen Mandanteninhaber übergehen ({count})',
      no_devices: 'Der Mandant hat keine Geräte, die übergehen.',
      end_customer_devices_unaffected: 'Geräte, die Endkunden gehören, sind nicht betroffen.',
      devices_changed:
        'Die Geräte des Mandanten haben sich geändert, seit der Dialog geöffnet wurde. Prüfe die aktuelle Liste und bestätige erneut.',
      consequences: {
        immediate: 'Der Wechsel wirkt sofort.',
        no_acceptance: 'Der neue Mandanteninhaber muss nicht zustimmen.',
        only_new_owner:
          'Danach können nur der neue Mandanteninhaber oder ein Organisations-Admin den Mandanteninhaber erneut wechseln.',
        demotion_self: 'Du wirst Mandanten-Admin und verlierst die Rechte des Mandanteninhabers.',
        demotion_other: '{name} wird Mandanten-Admin und verliert die Rechte des Mandanteninhabers.',
      },
      acknowledge_self: 'Mir ist klar, dass ich danach nur noch Mandanten-Admin bin.',
      acknowledge_other: 'Mir ist klar, dass {name} danach nur noch Mandanten-Admin ist.',
      confirm: 'Mandanteninhaber wechseln',
      nothing_changed: 'Es wurde nichts geändert.',
      rejections: {
        target_is_current_owner: 'Diese Person ist bereits Mandanteninhaber.',
        target_is_other_tenant_member: 'Diese Person gehört einem anderen Mandanten an.',
        target_is_only_invited: 'Diese Person ist nur eingeladen und noch kein Mitglied des Mandanten.',
        target_inactive: 'Das Konto dieser Person ist deaktiviert.',
        target_not_found: 'Diese Person ist kein Mitglied des Mandanten.',
        tenant_not_found: 'Der Mandant wurde nicht gefunden.',
        not_allowed: 'Du darfst den Mandanteninhaber nicht wechseln.',
      },
    },
    device_transfer: {
      header: 'Gerät übertragen',
      kind_label: 'Wohin soll das Gerät übertragen werden?',
      kind_tenant: 'An einen Tenant',
      kind_end_customer: 'An einen Endkunden',
      tenant_filter_placeholder: 'Tenant nach Namen suchen',
      no_tenants: 'Keine Tenants gefunden.',
      account_search_placeholder: 'Konto nach Name oder E-Mail suchen',
      no_accounts: 'Kein Konto gefunden.',
      no_account_hint:
        'Hat der Endkunde noch kein Konto, erreicht ihn das Gerät über eine Übergabe, nicht über eine Übertragung.',
      unavailable: {
        own_account: 'Nicht wählbar: Das ist dein eigenes Konto.',
        inactive: 'Nicht wählbar: Das Konto ist deaktiviert.',
        pending: 'Nicht wählbar: Das Konto ist noch nicht aktiviert.',
        tenant_member: 'Nicht wählbar: Das Konto gehört zu einem Tenant.',
      },
      show_preview: 'Weiter zur Vorschau',
      confirm: 'Übertragen',
      nothing_changed: 'Es wurde nichts geändert.',
      transferred: 'Das Gerät wurde übertragen.',
      preview: {
        device: 'Gerät',
        current_owner: 'Aktueller Eigentümer',
        tenant: 'Tenant mit Zugriff',
        target: 'Neuer Eigentümer',
        tenant_owner: 'Tenant Owner',
        losing_access: 'Verliert den Zugriff',
        keeping_access: 'Behält den Zugriff',
        open_handover: 'Offene Übergabe wird zurückgezogen',
        tenant_keeps_access:
          'Der Tenant behält den Zugriff auf das Gerät. Er kann danach entfernt werden.',
      },
      rejections: {
        target_is_tenant_member: 'Das Konto gehört inzwischen zu einem Tenant.',
        target_is_org_admin: 'An einen Organisations-Admin kann kein Gerät übertragen werden.',
        target_is_system_account: 'An das Systemkonto kann kein Gerät übertragen werden.',
        target_is_current_owner: 'Das Konto ist bereits Eigentümer des Geräts.',
        target_invalid: 'Das gewählte Ziel ist ungültig.',
        target_inactive: 'Das Konto ist deaktiviert.',
        target_not_found: 'Das Konto wurde nicht gefunden.',
        tenant_not_found: 'Der Tenant wurde nicht gefunden.',
      },
    },
    device_row_actions: {
      edit_device: 'Gerät bearbeiten',
      transfer_device: 'Gerät übertragen',
      remove_device: 'Gerät entfernen',
      edit_dialog: {
        header: 'Gerät bearbeiten',
        name_label: 'Gerätename',
        name_helper: 'Dies ist der Name, der für den Inhaber und alle anderen mit Zugriff sichtbar ist.',
        internal_name_label: 'Interner Name',
        internal_name_helper: 'Der interne Name dient der internen Zuordnung. Er ist weder für den Inhaber noch für andere außerhalb des Mandanten sichtbar.',
      },
      toasts: {
        device_updated: 'Gerät erfolgreich aktualisiert.',
        device_removed: 'Gerät erfolgreich entfernt.',
      },
    },
  },

  settings: {
    settings: 'Einstellungen',
    profile: 'Profil',
    app_settings: 'App-Einstellungen',
    payment: 'Zahlung',
    notifications: 'Benachrichtigungen',
    help: 'Hilfe',
    payment_details: 'Zahlungsplan und Bankdaten',
    notification_details: 'Welche Benachrichtigungen möchtest du erhalten?',
    profile_details: 'Name und Kontaktdaten',
    help_details: 'Hilfe, Kontakt & AGB',
    add_tenant: 'Mandant hinzufügen',
    subtitle: 'Name und Kontaktdaten',
  },

  plans: {
    select_plan: 'Wählen Sie Ihren Plan',
    subtitle: 'Individuell auf Ihre Bedürfnisse zugeschnitten',
    annual_pricing: 'Jährliche Preise',
    save_percentage: 'Sparen Sie {percentage} %',
    free_version: 'Kostenlose Version',
    subscribed: 'Abonniert',
    per_month: 'pro Monat',
    manage_devices: 'Verwalten Sie Ihre Geräte',
    global_access: 'Globaler Zugriff auf Geräte',
    cloud_optimization: 'Cloud+ Optimierung',
    enbas_plus: 'Enbas Plus',
    recommended: 'Empfohlen',
  },

  payments: {
    title: 'Zahlungen und Abonnements',
    cancel_subscription: 'Abonnement kündigen',
    enbas_plus: 'Enbas Plus',
    active: 'Aktiv',
    inactive: 'Inaktiv',
  },

  profile: {
    name: 'Name',
    email: 'Mailadresse',
    edit_profile: 'Profil bearbeiten',
    user_profile: 'Benutzerprofil',
    edit_your_profile: 'Dein Profil bearbeiten',
    logout: 'Abmelden',
    notifications: 'Benachrichtigungen',
    notifications_enabled: 'Aktiviert',
    notifications_disabled: 'Deaktiviert',
    delete_profile: 'Konto löschen',
    delete_account_owner_notice: 'Als Inhaber eines Mandanten kannst du dein Konto nicht löschen. Übertrage zuerst die Eigentümerschaft.',
    to_member_list: 'Zur Mitgliederliste',
    type_delete_to_confirm: 'Bitte schreiben Sie "delete"!',
    delete_error: 'Beim Löschen des Profils ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    language: 'Sprache',
    incorrect_old_password: 'Das eingegebene alte Passwort ist falsch.',
    password: 'Passwort',
    change_password: 'Passwort ändern',
    current_password: 'Aktuelles Passwort',
    edit_email: 'Mailadresse ändern',
    edit_name: 'Name ändern',
    edit_language: 'Sprache ändern',
    edit_password: 'Passwort ändern',
    edit_password_text: 'Gib dein aktuelles Passwort ein, um deine E-Mail-Adresse zu ändern.',
  },

  help: {
    title: 'Hilfe',
    terms_of_service: 'Allgemeine Geschäftsbedingungen',
    privacy_policy: 'Datenschutzrichtlinie',
    support: 'Support',
    imprint: 'Impressum',
    copyright: 'Copyright energielenker Solutions GmbH',
  },

  device: {
    active: 'Aktives Gerät',
    all_devices: 'Alle Geräte',
    lobas: 'Lobas',
    enbas: 'Enbas',
    device_name: 'Gerätename',
    device_updated: 'Gerät erfolgreich aktualisiert!',
    device_name_required: 'Gerätename ist erforderlich',
    internal_name: 'Interner Name',
    internal_name_helper: 'Der Mandanten-Tag dient als Hilfe für die interne Zuordnung. Er ist für den Besitzer oder Personen außerhalb des Mandanten nicht sichtbar.',
    device_help_before: 'Gib den Schlüssel in den Einstellungen deines Geräts ein.',
    device_help_link: 'Hier',
    device_help_after: 'findest du weitere Informationen dazu.',
    choose_device: 'Wähle einen Namen, um fortzufahren',
    choose_device_title: 'Gerät wählen',
    connect_device: 'Gerät verbinden',
    explanation: 'Nachdem du auf "Weiter" getippt hast, erhältst du einen Key, den du in die Administrationsoberfläche deines Geräts eingeben musst. Sobald dies erledigt ist, wird das Gerät verifiziert und du erkennst es mit dem Status "Verbunden" in der App.',
    exit_device: 'Gerät verlassen',
    view_mode: 'Derzeit im Enbas-Ansichtsmodus',
    currently_unavailable: 'Das Gerät ist derzeit nicht verfügbar (ausstehend oder getrennt).',
    first_setup_key: 'Erster Verbindungsschlüssel',
    device_settings: 'Geräte-Einstellungen',
    set_as_default: 'Als Standardgerät festlegen',
    set_as_default_help: 'Dieses Gerät wird geöffnet, wenn der Vollbild-Start aktiviert ist',
    device_information: 'Geräteinformationen',
    device_id: 'Geräte-ID',
    type: 'Typ',
    tenant_access: 'Mandantenzugriff',
    assigned_tenant: 'Zugewiesener Mandant',
    add_tenant: 'Mandant hinzufügen',
    tenant_assigned: 'Mandant erfolgreich zugewiesen!',
    no_tenant_access: 'Kein Mandant hat Zugriff auf dieses Gerät',
    removal: {
      device_label: 'Gerät',
      current_owner: 'Aktueller Besitzer',
      owner: 'Besitzer',
      losing_access: 'Verliert den Zugriff',
      open_handover: 'Offene Übergabe an',
      nothing_changed: 'Es wurde nichts geändert.',
      device: {
        action: 'Gerät entfernen',
        header: 'Gerät entfernen',
        effect: 'Das Gerät wird von energielenker connect getrennt. Lokale Einstellungen, Messdaten und Verlauf bleiben auf dem Gerät erhalten. Über seine eigene Weboberfläche lässt es sich später erneut koppeln.',
        confirm: 'Gerät entfernen',
        done: 'Gerät entfernt',
      },
      tenant_access: {
        action: 'Zugriff unseres Mandanten entfernen',
        action_named: 'Zugriff von {tenant} entfernen',
        header: 'Mandantenzugriff entfernen',
        effect: 'Der Mandant sieht und verwaltet das Gerät danach nicht mehr und kann den Zugriff nicht selbst zurückerlangen. Das Gerät bleibt beim Endkunden.',
        confirm: 'Zugriff entfernen',
        done: 'Mandantenzugriff entfernt',
      },
    },
    device_key: 'Geräteschlüssel',
    key_copied: 'Schlüssel kopiert',
    no_key_tooltip: 'Kein Schlüssel zum Kopieren vorhanden',
    save_settings: 'Einstellungen speichern',
    status_changed: "Status des Geräts {deviceType} {deviceName} wurde von {previousStatus} auf {newStatus} geändert",
    verification_short_key: 'Verifizierungsschlüssel',
    explanation_key: 'Du hast den Schlüssel bereits hinterlegt? Es kann eine Weile dauern, bis die Verbindung bestätigt wurde.',
    connect_tenant_label: 'Mandant',
    connect_tenant_notice: 'Das Gerät gehört dem gewählten Mandanten. Owner wird dessen Mandanteninhaber.',
    handover: {
      start: 'An Endkunden übergeben',
      title: 'Gerät an Endkunden übergeben',
      section: 'Übergabe an Endkunden',
      status_invited: 'Eingeladen',
      email_label: 'E-Mail-Adresse des Endkunden',
      invalid_email: 'Bitte gib eine gültige E-Mail-Adresse ein.',
      check: 'Prüfen',
      device: 'Gerät',
      recipient: 'Empfänger',
      case: {
        immediate: 'Zu dieser Adresse gibt es ein Konto. Die Übergabe wirkt sofort.',
        invitation: 'An diese Adresse geht eine Einladung. Die Übergabe wirkt, sobald der Endkunde sie annimmt.',
      },
      case_changed: 'Seit der Prüfung hat sich geändert, wie die Übergabe wirkt. Bitte bestätige erneut.',
      consequences: {
        title: 'Was die Übergabe bewirkt',
        owner: 'Der Endkunde wird Besitzer des Geräts.',
        tenant_keeps_access: 'Der Mandant des Geräts behält den Zugriff, bis der Zugriff entfernt wird.',
        only_access_removable: 'Der Mandant kann das Gerät danach nicht mehr entfernen, nur noch seinen eigenen Zugriff.',
      },
      confirm: 'Übergabe bestätigen',
      outcome: {
        immediate: 'Das Gerät wurde an {email} übergeben.',
        invitation: 'An {email} wurde eine Einladung gesendet. Das Gerät geht über, sobald sie angenommen wird.',
        invitation_resent: 'Die Übergabe wurde der offenen Einladung an {email} hinzugefügt. Die Einladungs-E-Mail wurde erneut gesendet.',
      },
      nothing_changed: 'Es wurde nichts geändert.',
      rejections: {
        recipient_is_org_admin: 'Diese Adresse gehört einem Organisations-Admin. An ihn kann kein Gerät übergeben werden.',
        recipient_is_self: 'Du kannst ein Gerät nicht an dich selbst übergeben.',
        recipient_is_member: 'Diese Adresse gehört einem Mitglied eines Mandanten. Geräte gehen nur an Endkunden.',
        account_deactivated: 'Das Konto zu dieser Adresse ist deaktiviert.',
        account_deletion_pending: 'Das Konto zu dieser Adresse wird gerade gelöscht. Die Adresse ist erst danach wieder verwendbar.',
        invitation_conflict: 'Für diese Adresse gibt es eine offene Einladung, mit der sich die Übergabe nicht verträgt. Sie muss zuerst zurückgezogen werden.',
        open_handover: 'Für dieses Gerät ist bereits eine Übergabe an {email} offen. Sie muss zuerst zurückgezogen werden.',
        device_not_found: 'Das Gerät wurde nicht gefunden.',
        not_allowed: 'Du darfst dieses Gerät nicht übergeben.',
        invalid_email: 'Die E-Mail-Adresse ist ungültig.',
      },
    },
    status: {
      warning: 'Dein Gerät ist noch nicht verifiziert. Das kann einige Momente dauern.',
      update: 'Überprüfung ausstehend. Bitte stelle sicher, dass du die neueste Version auf deinem Enbas verwendest.',
      error: 'Verbindung zum Gerät fehlgeschlagen. Prüfe, ob das Gerät mit dem Internet verbunden ist.',
      info: 'Die Verbindung wurde über die Geräteeinstellungen aufgehoben.'
    },
    pending: 'Ausstehend',
    connected: 'Verbunden',
    disconnected: 'Getrennt',
    connection_lost: 'Verbindung verloren',
    connection_failed: 'Update erforderlich',
    showing_entries: '{first}-{last} von {total} Einträgen',
  },

  steps: {
    new_device_title: 'Gerätname wählen',
    new_device_description: 'Füge ein neues Gerät in der App hinzu.',
    enter_key_title: 'Key eingeben',
    enter_key_description: 'Hinterlege den Schlüssel in den Geräteeinstellungen.',
    ready_to_go_title: 'Fertig!',
    ready_to_go_description: 'Du kannst loslegen!'
  },

  install_app: {
    install: 'Installiere unsere App.',
    open_safari: 'Safari öffnen',
    tap: 'tippen',
    teilen: 'Teilen',
    add_to_home: 'Zum Startbildschirm hinzufügen',
    better_exp: 'für ein besseres Benutzererlebnis!',
    dann: 'dann',
  },

  optimize: {
    title: 'Möchten Sie die Leistung Ihres Geräts maximieren?',
    subtitle: 'Nutzen Sie das volle Potenzial von Enbas mit einem Optimierungsplan',
    learn_more: 'Mehr erfahren',
    dismiss: 'Schließen'
  },

  filter: {
    show_disconnected_devices: 'Getrennte Geräte anzeige',
    show_connected_devices: 'Verbundene Geräte anzeigen',
    show_also_users_without_devices: 'Benutzer ohne Geräte einschließen',
    show_enbas_devices: 'ENBAS-Geräte anzeigen',
    show_lobas_devices: 'LOBAS-Geräte anzeigen',
    filter: 'Filter',
    search: 'Suche',
    remove_filters: 'Filter zurücksetzen',
    sort_by: 'Sortieren nach',
    device_type: 'Device Type',
    status: 'Status',
    organisation: 'Organisation',
    select_all: 'Alle auswählen',
    show_all: 'Zeige alle',
    all: 'Alle',
    search_columns: 'Spalten durchsuchen',
    sort_options: {
      name: 'Vorname Nachname',
      alphabetical: 'Alphabetisch',
    },
    search_by_options: {
      username: 'Benutzername',
      email: 'E-Mail',
      device_name: 'Gerätename',
      device_serial: 'Seriennummer',
    },
    search_by_placeholder: 'Suchen nach',
    search_placeholder_generic: 'Suchen',
    search_placeholders: {
      username: 'Nach Benutzername suchen',
      email: 'Nach E-Mail suchen',
      device_name: 'Nach Gerätename suchen',
      device_serial: 'Nach Seriennummer suchen',
    },
    types: {
      enbas: 'Enbas',
      lobas: 'Lobas',
    },
    statuses: {
      connected: 'Verbunden',
      pending: 'Verifizierung ausstehend',
      update_required: 'Update required',
      disconnected: 'Verbindung getrennt',
      connection_lost: 'Verbindung verloren',
    },
  },

  notifications: {
    deviceStatusChanged: "Gerät {deviceId} wurde von {from} zu {to} geändert",
    load_error: 'Benachrichtigungseinstellungen konnten nicht geladen werden. Bitte versuche es erneut.',
    update_error: 'Benachrichtigungseinstellung konnte nicht aktualisiert werden. Bitte versuche es erneut.',
    no_topics: 'Keine Benachrichtigungsthemen verfügbar.',
    tenant: {
      membership_added: 'Du wurdest als {role} zum Mandanten {tenantName} hinzugefügt.',
      membership_removed: 'Du wurdest aus dem Mandanten {tenantName} entfernt.',
      role_changed: 'Deine Rolle in {tenantName} wurde zu {role} geändert.',
      ownership_transferred: 'Du bist jetzt der Eigentümer von {tenantName}.',
      renamed: 'Der Mandant heißt jetzt {tenantName}.',
      device_access_removed: '{tenantName} hat keinen Zugriff mehr auf {count} Gerät(e), weil deren Eigentümer jetzt Inhaber eines eigenen Mandanten ist.',
    },
    status: {
      pending_connected: "Dein {deviceType} {deviceName} hat sich erfolgreich verbunden.",
      connected_disconnected: "Dein {deviceType} {deviceName} wurde getrennt.",
      disconnected_connected: "Dein {deviceType} {deviceName} ist wieder verbunden.",
      connected_connection_lost: "Dein {deviceType} {deviceName} hat die Verbindung verloren.",
      connection_lost_connected: "Dein {deviceType} {deviceName} hat sich erfolgreich wieder verbunden.",
      update_required_connected: "Dein {deviceType} {deviceName} wurde aktualisiert und ist wieder verbunden.",
      update_required_disconnected: "Dein {deviceType} {deviceName} wurde getrennt und benötigt noch ein Update.",
      connection_lost_disconnected: "Dein {deviceType} {deviceName} ist nicht mehr erreichbar und wurde getrennt.",
      pending: "Dein {deviceType} {deviceName} wartet auf Verbindung.",
      update_required: "Dein {deviceType} {deviceName} benötigt ein Update.",
      fallback: "Statusupdate für {deviceType} {deviceName}"
    }
  },

  password: {
    submission_errors: 'Bei Ihrer Übermittlung sind {errorsNum} Fehler aufgetreten',
    password_valid: 'Ihr Übermittlung erfüllt alle Anforderungen.',
    password_errors: {
      length: 'Ihr Passwort muss mindestens 8 Zeichen lang sein',
      uppercase: 'Mindestens 1 Großbuchstabe',
      lowercase: 'Mindestens 1 Kleinbuchstabe',
      number: 'Mindestens 1 Zahl',
      specialChar: 'Mindestens 1 Sonderzeichen',
      mismatch: 'Passwörter stimmen nicht überein',
      max_length: 'Passwort ist nicht zu lang',
    }
  },


  form: {
    no_errors_in_form: 'Ihr Formular erfüllt alle Anforderungen.',
    submission_errors: 'Bei Ihrer Übermittlung sind {errorsNum} Fehler aufgetreten.',
    errors: {
      invalid_email: 'Ungültige Mailadresse',
      first_name_short: 'Vorname ist zu kurz',
      last_name_short: 'Nachname ist zu kurz',
      first_name_too_long: 'Vorname ist zu lang',
      last_name_too_long: 'Nachname ist zu lang',
      email_too_long: 'Mailadresse ist zu lang',
      email_required: 'Mailadresse fehlt',
    }
  },

  page_titles: {
    welcome: 'Willkommen',
    signup_login: 'Einloggen oder Registrieren',
    sign_up: 'Registrieren',
    sign_in: 'Einloggen',
    signup_success: 'Registrierung Erfolgreich',
    forgot_password: 'Passwort vergessen',
    reset_password: 'Passwort zurücksetzen',
    user_verify: 'Benutzer verifizieren',
    edit_password: 'Passwort ändern',
    edit_name: 'Name ändern',
    edit_email: 'Mailadresse ändern',

    plans: 'Pläne',
    profile: 'Profil',
    edit_profile: 'Profil bearbeiten',
    notifications: 'Meldungen',
    help: 'Hilfe',
    payments: 'Zahlungsmethoden',
    settings: 'Einstellungen',
    home: 'Geräte',
    edit_device: 'Gerät bearbeiten',
    not_authorized: 'Nicht autorisiert',
    sso_success: 'SSO-Anmeldung erfolgreich',
    sso_fail: 'SSO-Anmeldung fehlgeschlagen',
    admin: 'Verwaltung',
  },
  offline: {
    headline: 'Wir sind gleich wieder da!',
    message: 'Unser System wird gerade gewartet, damit du bald ein noch besseres Erlebnis hast. Bitte schau später wieder vorbei.',
  },
  layout: {
    collapse_sidebar: 'Seitenleiste einklappen',
    expand_sidebar: 'Seitenleiste ausklappen',
  },
  navigation: {
    system_status: 'Systemstatus',
  },
  tenant_owner_notice: {
    header: 'Du bist Inhaber von {tenantName}',
    message: 'Geräte deiner Kunden und deines Betriebs gehören in dieses geschäftliche Konto. Deine eigenen Geräte gehören in ein separates privates Konto. Connect trennt beides innerhalb eines Kontos nicht.',
    confirm: 'Verstanden',
  },
  invitations: {
    tab: 'Einladungen',
    platform_title: 'Offene Einladungen',
    empty: 'Es gibt keine offenen Einladungen.',
    tenant: 'Mandant',
    end_customer: 'Endkunde',
    attached_by: 'Angehängt von',
    attached_by_unknown: 'Angehängt von einem nicht mehr bekannten Konto',
    invited_on: 'Eingeladen am',
    last_sent_on: 'Zuletzt gesendet am',
    resend: 'Erneut senden',
    ownership_ends_with_tenant:
      'Die Einladung zur Eigentümerschaft kann nicht zurückgezogen werden. Sie endet nur, wenn der Mandant gelöscht wird.',
    filter: {
      tenants: 'Mandanten',
      end_customer: 'Endkunden',
    },
    actions: {
      membership: 'Mitglied (Techniker) in {tenant}',
      device_handover: 'Übergabe von Gerät {device}',
      tenant_ownership: 'Eigentümerschaft von {tenant}',
    },
    withdraw: {
      button: 'Zurückziehen',
      header: 'Einladung zurückziehen',
      message: 'Die Einladung an diese Adresse wird zurückgezogen. Damit entfällt:',
      confirm: 'Zurückziehen',
    },
    toasts: {
      resent: 'Einladung erneut an {email} gesendet.',
      withdrawn: 'Einladung an {email} zurückgezogen.',
    },
    errors: {
      not_resendable: 'Diese Einladung kann nicht erneut gesendet werden.',
      not_open: 'Diese Einladung ist nicht mehr offen.',
      ownership_not_withdrawable: 'Eine Einladung zur Eigentümerschaft kann nicht zurückgezogen werden.',
      resent_too_soon: 'Diese Einladung wurde gerade erst gesendet. Bitte versuche es in einer Minute erneut.',
      not_allowed: 'Dazu fehlt dir die Berechtigung.',
      not_found: 'Die Einladung wurde nicht gefunden.',
    },
  },
};

export default de;
